<template>
	<div class="assessment_wrap" :style="'height:'+height">
		<div class="assessment_cont">
			<div class="top_title">
				<h3>设置考试标准</h3>
				<el-button type="primary" @click="saveAssessment">保存</el-button>
			</div>
			<ul>
				<li>
					<span class="title_label">课程满分</span>
					<span>100分</span>
				</li>
				<li>
					<span class="title_label">学生成绩</span>
					<span>=（完成课件任务数/课件总任务数）*100 * 课件学习权重 + 单元测验平均分 * 单元测验权重 + 课程考试得分 * 课程考试权重 + 出勤率 * 100 * 考勤签到权重</span>
				</li>
				<li class="third">
					<span class="title_label">权重设置</span>
					<div class="ipt">
						<div class="ipt-items">
							<div class="ipt-item">
								<span>课件学习</span><i></i>
								<el-input v-model="courseware"></el-input>
							</div>
							<span>%</span>
						</div>
						<div class="ipt-items">
							<div class="ipt-item">
								<span>单元测验</span><i></i>
								<el-input v-model="unitTest"></el-input>
							</div>
							<span>%</span>
						</div>
						<div class="ipt-items">
							<div class="ipt-item">
								<span>课程考试</span><i></i>
								<el-input v-model="curriculum"></el-input>
							</div>
							<span>%</span>
						</div>
						<div class="ipt-items">
							<div class="ipt-item">
								<span>考勤签到</span><i></i>
								<el-input v-model="signIn"></el-input>
							</div>
							<span>%</span>
						</div>
					</div>
				</li>
				<p>注：各考核项权重之和为100%</p>
			</ul>
		</div>
	</div>
</template>

<script>
	import * as api from "../../../../api/individualApi";
	export default {
		data(){
			return {
				height:window.innerHeight - 236+"px",
				courseware:0,
				unitTest:0,
				curriculum:0,
				signIn:0
			}
		},
		created(){
			this.getTestStandard();
		},
		methods: {
			// 保存课程考核
			saveAssessment(){
				if(this.judgeNumber(this.courseware*1) && this.judgeNumber(this.unitTest*1) && this.judgeNumber(this.curriculum*1) && this.judgeNumber(this.signIn*1)){
					if(this.courseware*1+this.unitTest*1+this.curriculum*1+this.signIn*1 == 100){
						let courseId = this.$route.query.courseId;
						let arr = [
							{appraiseId:1,
							appraiseValue:this.courseware*1},
							{appraiseId:2,
							appraiseValue:this.unitTest*1},
							{appraiseId:3,
							appraiseValue:this.curriculum*1},
							{appraiseId:4,
							appraiseValue:this.signIn*1}
						];
						api.saveAssessment(courseId,arr).then(res=>{
							console.log(res)
							if(res.code == 0){
								this.$messageSuccess('保存成功');
							}else{
								this.$messageError(res.msg);
							}
						})
					}else{
						this.$messageError('各考核项权重之和为100%,请重新输入');
			      return;
					}
				}else{
					this.$messageError('各考核项权重必须为整数,请重新输入');
		      return;
				}
			},
			// 正整数正则
			judgeNumber(num){
				var reg = /^[0-9]\d*$/;
				return reg.test(num);
			},
			// 课程考核回显
      getTestStandard(){
      	let courseId = this.$route.query.courseId;
      	api.getTestStandard(courseId).then(res=>{
      		console.log(res);
      		if(res.code == 0){
      			if(res.data.length){
      				this.courseware = res.data[0].appraiseValue?res.data[0].appraiseValue:0;
	      			this.unitTest = res.data[1].appraiseValue?res.data[1].appraiseValue:0;
	      			this.curriculum = res.data[2].appraiseValue?res.data[2].appraiseValue:0;
	      			this.signIn = res.data[3].appraiseValue?res.data[3].appraiseValue:0;
      			}
      		}
      	}).catch((error)=>{
          console.log(error)
        })
      },
		}
	}
</script>

<style lang="scss" scoped>
	.assessment_wrap {
		background: #fff;
		overflow-y: auto;
		.assessment_cont {
			padding: 20px 24px;
			padding-top: 0;
			.top_title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 10px;
				h3 {
					font-size: 16px;
					color: #0D141E;
					font-weight: bold;
				}
				.el-button {
					padding: 9px 27px;
				}
			}
			p {
				font-size: 12px;
				color: #858C96;
				margin-left: 76px;
			}
			ul {
				li {
					margin-bottom: 24px;
					.title_label {
						font-weight: bold;
						font-family:Hiragino Sans GB;
						margin-right: 20px;
					}
					span {
						font-size: 14px;
						color: #0D141E;
					}
				}
			}
			.third {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				.ipt {
					display: flex;
					align-items: center;
					justify-content: space-between;
					span {
						margin-left: 4px;
					}
					.ipt-items {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-right: 58px;
					}
					.ipt-item {
						width: 156px;
						height: 32px;
						background: #F1F2F4;
						border-radius: 2px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						span {
							font-size: 12px;
							color: #A0A0A6;
							margin-left: 8px;
							margin-right: 8px;
						}
						i {
							width:0px;
							height:16px;
							border:1px solid rgba(188,188,194,1);
						}
						/deep/ .el-input {
							width: 90px;
							.el-input__inner {
								height: 32px;
								line-height: 32px;
								border: 0;
								background: #F1F2F4;
								border-radius: 2px;
							}
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/courseAssessment.vue